import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { AvatarCircles } from "../magicui/avatar-circles";
import BasicBlock from "../shared/basic-block";
type IconProps = React.HTMLAttributes<SVGElement>;

const YoutubeIcon = (props: IconProps) => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-5", props.className)}
      {...props}
    >
      <path
        d="M21.0201 2.85288C21.5 4.72398 21.5 8.62998 21.5 8.62998C21.5 8.62998 21.5 12.536 21.0201 14.4071C20.7534 15.4413 19.9733 16.2551 18.9852 16.5302C17.1908 17.03 11 17.03 11 17.03C11 17.03 4.81235 17.03 3.01475 16.5302C2.0225 16.2509 1.2434 15.4382 0.97985 14.4071C0.5 12.536 0.5 8.62998 0.5 8.62998C0.5 8.62998 0.5 4.72398 0.97985 2.85288C1.24655 1.81863 2.0267 1.00488 3.01475 0.72978C4.81235 0.22998 11 0.22998 11 0.22998C11 0.22998 17.1908 0.22998 18.9852 0.72978C19.9775 1.00908 20.7566 1.82178 21.0201 2.85288ZM8.9 12.305L15.2 8.62998L8.9 4.95498V12.305Z"
        fill="#335CFF"
      />
    </svg>
  );
};

const InstagramIcon = (props: IconProps) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-5", props.className)}
      {...props}
    >
      <path
        d="M11 0.129883C13.8528 0.129883 14.2088 0.140383 15.3281 0.192883C16.4463 0.245383 17.2076 0.420733 17.8775 0.681133C18.5705 0.947833 19.1543 1.30903 19.7381 1.89178C20.272 2.41667 20.6852 3.0516 20.9487 3.75238C21.2081 4.42123 21.3845 5.18353 21.437 6.30178C21.4863 7.42108 21.5 7.77703 21.5 10.6299C21.5 13.4827 21.4895 13.8387 21.437 14.958C21.3845 16.0762 21.2081 16.8375 20.9487 17.5074C20.6859 18.2085 20.2727 18.8436 19.7381 19.368C19.2131 19.9017 18.5782 20.3148 17.8775 20.5786C17.2086 20.838 16.4463 21.0144 15.3281 21.0669C14.2088 21.1162 13.8528 21.1299 11 21.1299C8.14715 21.1299 7.7912 21.1194 6.6719 21.0669C5.55365 21.0144 4.7924 20.838 4.1225 20.5786C3.42144 20.3156 2.7864 19.9024 2.2619 19.368C1.72788 18.8432 1.31473 18.2082 1.05125 17.5074C0.79085 16.8385 0.6155 16.0762 0.563 14.958C0.51365 13.8387 0.5 13.4827 0.5 10.6299C0.5 7.77703 0.5105 7.42108 0.563 6.30178C0.6155 5.18248 0.79085 4.42228 1.05125 3.75238C1.314 3.05117 1.72724 2.41607 2.2619 1.89178C2.78655 1.35758 3.42155 0.944399 4.1225 0.681133C4.7924 0.420733 5.5526 0.245383 6.6719 0.192883C7.7912 0.143533 8.14715 0.129883 11 0.129883ZM11 5.37988C9.60761 5.37988 8.27225 5.93301 7.28769 6.91757C6.30312 7.90214 5.75 9.2375 5.75 10.6299C5.75 12.0223 6.30312 13.3576 7.28769 14.3422C8.27225 15.3268 9.60761 15.8799 11 15.8799C12.3924 15.8799 13.7277 15.3268 14.7123 14.3422C15.6969 13.3576 16.25 12.0223 16.25 10.6299C16.25 9.2375 15.6969 7.90214 14.7123 6.91757C13.7277 5.93301 12.3924 5.37988 11 5.37988ZM17.825 5.11738C17.825 4.76929 17.6867 4.43545 17.4406 4.1893C17.1944 3.94316 16.8606 3.80488 16.5125 3.80488C16.1644 3.80488 15.8306 3.94316 15.5844 4.1893C15.3383 4.43545 15.2 4.76929 15.2 5.11738C15.2 5.46548 15.3383 5.79932 15.5844 6.04546C15.8306 6.2916 16.1644 6.42988 16.5125 6.42988C16.8606 6.42988 17.1944 6.2916 17.4406 6.04546C17.6867 5.79932 17.825 5.46548 17.825 5.11738ZM11 7.47988C11.8354 7.47988 12.6366 7.81176 13.2274 8.4025C13.8181 8.99324 14.15 9.79445 14.15 10.6299C14.15 11.4653 13.8181 12.2665 13.2274 12.8573C12.6366 13.448 11.8354 13.7799 11 13.7799C10.1646 13.7799 9.36335 13.448 8.77261 12.8573C8.18187 12.2665 7.85 11.4653 7.85 10.6299C7.85 9.79445 8.18187 8.99324 8.77261 8.4025C9.36335 7.81176 10.1646 7.47988 11 7.47988Z"
        fill="#335CFF"
      />
    </svg>
  );
};

const CoFounderHeader = (
  <h3 className="text-center text-[33px] font-semibold md:text-[48px]">Meet our Co-Founder</h3>
);

export const CoFounder = () => {
  return (
    <BasicBlock header={CoFounderHeader} wrapperStyle="md:gap-[45px] md:py-[100px]">
      <div className="flex items-center justify-center rounded-2xl border border-[#CACFD8] bg-[#F9FBFF] p-[12px] md:px-[61px] md:py-[66px]">
        <div className="flex flex-col gap-8 lg:grid lg:grid-cols-3 lg:gap-12">
          <div className="flex flex-col items-start gap-4 md:flex-row md:items-end lg:flex-col lg:items-start">
            <div className="aspect-square w-48 shrink-0 rounded-3xl lg:w-full">
              <div className="relative h-full overflow-hidden rounded-3xl border-8 border-[#ebf2ff] bg-[#c5d9ff]">
                <Image
                  src="https://cdn-crayo.com/lp/public/landing/musa.png"
                  alt="co-founder"
                  width={500}
                  height={500}
                  className="absolute bottom-0 left-[50%] -translate-x-1/2"
                  draggable={false}
                  style={{
                    touchAction: "none",
                    userSelect: "none",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-1">
                <p className="text-4xl font-semibold">Musa Mustafa</p>
                <p className="text-[18px] text-[#525866]">CMO + Co-Founder of Crayo</p>
              </div>
              <div className="flex items-center gap-3">
                <Link
                  href="https://www.youtube.com/@MussyMakesMoney"
                  target="_blank"
                  className="border-[#2C3F8D]/18 group flex size-[56px] items-center justify-center rounded-full border bg-transparent"
                >
                  <YoutubeIcon className="transition-all duration-300 group-hover:opacity-80" />
                </Link>
                <Link
                  href="https://www.instagram.com/mussy.02/"
                  target="_blank"
                  className="border-[#2C3F8D]/18 group flex size-[56px] items-center justify-center rounded-full border bg-transparent"
                >
                  <InstagramIcon className="transition-all duration-300 group-hover:opacity-80" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-span-2 flex flex-col gap-10 md:gap-20">
            <p className="musa-quote !text-[18px] lg:!text-[30px]">
              &quot;I&apos;ve gone viral for myself, and the most popular content creators. I know
              how to go viral, and made the best video editor to make going viral easy for
              anyone.&quot;
            </p>
            <div className="flex flex-col gap-2">
              <p className="text-3xl">Edited for</p>
              <AvatarCircles />
            </div>
          </div>
        </div>
      </div>
    </BasicBlock>
  );
};
